<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{"Swap Roller Position" | translate| async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close">close</i>
  </div>




  <div class="ttmodal__body" *ngIf="!isloading">
      {{'Selected Component' | translate | async }} {{ selectedComponent.Name }} {{'Currently At Position'| translate | async}} {{selectedComponent.ActualPosition}}
        <mat-form-field class="setup-form-full-width">
            <mat-select name="Roller To Swap" placeholder="{{'Select Swap component' | translate | async}}">
              <mat-option *ngFor="let roller of allRollers"  (click)="swapRollerEvent(roller)" [value]="roller">
                {{ roller.Name }}  {{ roller.Position }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="ttmodal__footer">
            <button mat-raised-button (click)="onNoClick()">Cancel</button>
          </div>

  </div>

</div>
